import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

// Public renderer for admin-authored Web Design pages (route /web/:slug).
// The document is rendered inside a strongly-sandboxed iframe: sandbox="allow-scripts"
// WITHOUT allow-same-origin → opaque origin, no access to this app's DOM, cookies,
// localStorage, tokens or secrets. A strict CSP is embedded in the document itself.
export default function WebPage() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    let alive = true;
    api.wdPublicPage(slug)
      .then((d) => { if (alive) { setState({ loading: false, doc: d.document, name: d.name }); if (d?.name) document.title = d.name; } })
      .catch((e) => {
        const code = e?.response?.status;
        if (alive) setState({ loading: false, error: code === 402 ? "pro" : "notfound" });
      });
    return () => { alive = false; };
  }, [slug]);

  if (state.loading) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0A0A0A", color: "#fff", fontFamily: "system-ui,Arial,sans-serif" }} data-testid="webpage-loading">
        Loading…
      </div>
    );
  }
  if (state.error === "pro") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, background: "#0A0A0A", color: "#fff", fontFamily: "system-ui,Arial,sans-serif" }} data-testid="webpage-pro">
        <div style={{ fontSize: 22, fontWeight: 700 }}>This page requires Pro</div>
        <a href="/pricing" style={{ background: "#00F0FF", color: "#000", padding: "10px 20px", borderRadius: 999, fontWeight: 700, textDecoration: "none" }}>Upgrade to Pro</a>
      </div>
    );
  }
  if (state.error) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 8, background: "#0A0A0A", color: "#fff", fontFamily: "system-ui,Arial,sans-serif" }} data-testid="webpage-404">
        <div style={{ fontSize: 48, fontWeight: 800 }}>404</div>
        <div style={{ color: "#A1A1AA" }}>This page could not be found.</div>
      </div>
    );
  }
  return (
    <iframe
      title={state.name || "Web Page"}
      srcDoc={state.doc}
      sandbox="allow-scripts allow-popups allow-forms"
      referrerPolicy="no-referrer"
      style={{ border: "none", width: "100vw", height: "100vh", display: "block" }}
      data-testid="webpage-frame"
    />
  );
}
